module.exports = __webpack_public_path__ + "img/514.2dc2c517.jpg";